import { useMemo } from 'react';
import { useEnabledFeatures } from '../hooks/useEnabledFeatures';
import {
  STORYBOOK_ACCOUNTS_QUERY_KEY,
  useAccountsQuery,
} from './useAccountsQuery';
import { getBankAccountSelectOptions } from './useBankAccountSelectOptionsQuery.utils';

export const STORYBOOK_BANK_ACCOUNT_SELECT_OPTIONS_QUERY_KEY =
  STORYBOOK_ACCOUNTS_QUERY_KEY;

export {
  getBankAccountSelectOptions,
  getBankAccountSelectOptionsQuery,
} from './useBankAccountSelectOptionsQuery.utils';

export function useBankAccountSelectOptionsQuery(args?: { skip?: boolean }) {
  const { OPEX } = useEnabledFeatures();

  const queryData = useAccountsQuery({
    skip: args?.skip,
    storybookQueryKey: STORYBOOK_BANK_ACCOUNT_SELECT_OPTIONS_QUERY_KEY,
  });

  const data = useMemo(
    () =>
      queryData.data
        ? getBankAccountSelectOptions(queryData.data, OPEX)
        : undefined,
    [queryData.data, OPEX]
  );

  return {
    ...queryData,
    data,
  };
}
